export const CIVILITIES = ['monsieur', 'madame'] as const;

export type Civility = (typeof CIVILITIES)[number];

export const CIVILITY_LABELS: Record<Civility, string> = {
  monsieur: 'Monsieur',
  madame: 'Madame',
};

/** Select value for an unknown civility, stored as null. */
export const NO_CIVILITY = 'none';
